<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Acknowledgments">Acknowledgements</a></p>
<p class="toc1"><a href="#/Chapter1">1. Off to War</a></p>
<p class="toc"><a href="#/Chapter2">2. The City They Left Behind</a></p>
<p class="toc"><a href="#/Chapter3">3. The Third Michigan Goes to War</a></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. A City of Horse Soldiers</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. Building Bridges and Engineering Victory</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. Earning the Right to Be Called Veterans</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. War Affects the Valley City</span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">8. Experiencing the Peculiar Institution</span></p>
<p class="toc"><span href="#/Chapter9" title="Link target outside of Sample">9. The Harder Part of the War</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">10. Mostly Tears and an Occasional Smile</span></p>
<p class="toc"><span href="#/Chapter11" title="Link target outside of Sample">11. The Joy of Victory</span></p>
<p class="toc"><span href="#/Chapter12" title="Link target outside of Sample">12. Those Who Did Not Come Right Home</span></p>
<p class="toc"><span href="#/Chapter13" title="Link target outside of Sample">13. A Matter of Remembering</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?2828bade